import Modal from "../../../components/Modal/Modal"
import styles from './GivewayWinnerModal.module.css'
import type { LeaderboardData } from '../types/leaderboard';
import { useState } from "react";

interface TournamentLeaderboardProps {
    data: LeaderboardData;
}

const GivewayWinnerModal = ({ icon, data }: { icon: string, data: LeaderboardData | undefined }) => {

    const getTrophy = (placement: number) => {
        const placementStore: { [key: number]: string } = {
            1: styles.first,
            2: styles.second,
            3: styles.third,
        };
        return placementStore[placement] ?? styles.default;
    };


    return (
        <Modal>
            <div className={styles.container}>
                <div className={styles.giftIcon}>
                    <img src={icon} alt="gift" />
                </div>
                <div className={styles.textContainer}>
                    <div className={styles.textTitle}>
                        Mega spin
                    </div>
                    <div className={styles.textSubtitle}>
                        Победители (29.11.2025 - 16:05)
                    </div>
                </div>
                <div className={styles.leaderboard}>
                    <div className={styles.entriesContainer}>
                        {data && data.current_month.map((entry) => (
                            <div key={entry.user.id} className={styles.listEntry}>
                                <div className={styles.avatarAndRank}>
                                    <div className={styles.avatar}>
                                        <img src={entry.user.photo_url} alt="Profile picture" />
                                    </div>
                                    <div className={`${styles.rank} ${getTrophy(entry.placement)}`}>
                                        <p>{entry.placement}</p>
                                    </div>
                                </div>
                                <div className={styles.userName}>
                                    <p className={styles.userNameText}>{entry.user.username}</p>
                                </div>
                                <div className={styles.coins}>
                                    <div className={styles.coinIconSmall}></div>
                                    <span className={styles.coinValue}>
                                        {entry.earned.amount.toLocaleString()}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default GivewayWinnerModal